import { Module, Action, Mutation } from "vuex-module-decorators";
import { httpServer as http } from "@/http/tbrScanAxios";
import PaginationModule from "@/store/base-modules/PaginationModule";
import type { PaginationDataState } from "@/types";
import { RootState } from "@/store";
export interface WarehouseHistoryState extends PaginationDataState {
  scanType: string;
  scanStartTim: string;
  scanEndTime: string;
}

@Module({ name: "K2OutInModule", namespaced: true })
export default class K2OutInModule {
  @Action
  async queryK2AppScanDetailsByScanCode(params) {
    const res = await http(
      "/k2-scan/app/scan-record/queryK2AppScanDetailsByScanCode",
      params
    );
    return res;
  }
  @Action
  async getOutboundWexinQrCodeUrl(params) {
    const res = await http(
      "/k2-scan/scan/out/result/getWexinQrCodeUrl",
      params
    );
    return res;
  }
  @Action
  async queryOutboundInfo(params) {
    const res = await http(
      "/k2-scan/scan/out/result/queryOutboundInfo",
      params
    );
    return res;
  }
}
